var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarGoodLokkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_x2C__transport_x2C__navigation_x2C__pin_x2C__vehicle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_268_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "    M29.5,27.5v2c0,0.55-0.45,1-1,1h-1c-0.55,0-1-0.45-1-1v-2",
    fill: "none",
    id: "XMLID_3822_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_281_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.5,
    x2: 16.5,
    y1: 27.5,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M19.5,20.5c8.5,0,11,0.583,11,3v1.188",
    fill: "none",
    id: "XMLID_280_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M26.5,25.5v-1c0-0.55,0.45-1,1-1h3v2H26.5z",
    fill: "none",
    id: "XMLID_279_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M18.5,23.5h4c1.104,0,2,0.896,2,2l0,0",
    fill: "none",
    id: "XMLID_277_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M28.569,21.206L26.82,15.95c-0.181-0.53-0.761-1.02-1.311-1.09c-0.775-0.098-1.973-0.221-3.444-0.295",
    fill: "none",
    id: "XMLID_276_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_804_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "     M8.439,1.85C9.254,1.621,10.113,1.5,11,1.5c5.245,0,9.5,4.254,9.5,9.5c0,8.063-9.5,19.5-9.5,19.5S1.5,19.063,1.5,11     c0-2.697,1.125-5.133,2.931-6.861",
    fill: "none",
    id: "XMLID_805_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    fill: "none",
    id: "XMLID_3807_",
    r: 5.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_1915_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.5,
    x2: 11,
    y1: 30.5,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_2107_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.6,
    x2: 1.5,
    y1: 30.5,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_732_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.5,
    x2: 27.5,
    y1: 30.5,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_2200_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.6,
    x2: 1.5,
    y1: 30.5,
    y2: 30.5
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_171_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.577,
    x2: 6.493,
    y1: 2.508,
    y2: 2.563
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_170_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.577,
    x2: 6.493,
    y1: 2.508,
    y2: 2.563
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarGoodLokkingIcon);
export default __webpack_public_path__ + "static/media/carGoodLokkingIcon.0da270722afc6267585e1bed2f22a8e0.svg";
export { ForwardRef as ReactComponent };